<?xml version="1.0"?>
<svg
  viewBox="0 0 24 24"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    data-player="true"
    fill="#808080"
    d="M12,13H3a1,1,0,0,1-1-1A10,10,0,0,1,12,2a1,1,0,0,1,1,1v9A1,1,0,0,1,12,13ZM4.06,11H11V4.06A8,8,0,0,0,4.06,11Z"
  />
  <path
    data-player="true"
    fill="#808080"
    d="M12,22a1,1,0,0,1-1-1V12a1,1,0,0,1,1-1h9a1,1,0,0,1,1,1A10,10,0,0,1,12,22Zm1-9v6.94A8,8,0,0,0,19.94,13Z"
  />
  <path
    data-player="true"
    fill="#808080"
    d="M20.05,9a1,1,0,0,1-.89-.55,8,8,0,0,0-3.61-3.61A1,1,0,0,1,15.1,3.5a1,1,0,0,1,1.35-.45A10.2,10.2,0,0,1,21,7.55,1,1,0,0,1,20.05,9Z"
  />
  <path
    data-player="true"
    fill="#808080"
    d="M8,21.05a1,1,0,0,1-.45-.1,10.2,10.2,0,0,1-4.5-4.5A1,1,0,0,1,3.5,15.1a1,1,0,0,1,1.34.45,8,8,0,0,0,3.61,3.61A1,1,0,0,1,8,21.05Z"
  />
</svg>
